import { GET, POST, PUT } from './api';

const table = 'alerta-cobrancas';

// Avisos fixos no topo da tela do contrato, visiveis a todo o distribuidor.
// Nao existe Delete: o endpoint retorna 403 porque quem baixou um "nao
// acionar" precisa ficar registrado. Para encerrar, use Encerrar.
export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
};

export const Read = async (filters = '') => {
  return await GET(`/${table}${filters}`, true);
};

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
};

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
};

// Traz os alertas do contrato somados aos do cliente dono dele, ja ordenados
// por gravidade. Resposta: { total, criticos, alertas }.
export const ReadByCobranca = async (id) => {
  return await GET(`/${table}/cobranca/${id}`, true);
};

// Alertas vigentes de todos os contratos que o usuario enxerga, numa chamada
// so, para marcar as linhas do grid. O find do back ja descarta encerrados e
// expirados e escopa por distribuidor; o pageSize evita a paginacao padrao de
// 25 esconder alerta de contrato que esta no fim da lista.
export const ReadVigentes = async () => {
  return await GET(`/${table}?pagination[pageSize]=500`, true);
};

export const Encerrar = async (id, motivo) => {
  return await PUT(
    `/${table}/${id}`,
    { data: { ativo: false, motivo_resolucao: motivo } },
    true
  );
};
